module.exports = __webpack_public_path__ + "img/63.235fbf23.png";